import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';

import { HttpClientService } from '../common/http-client.service';

import { AutocompleteResult } from '../../models/autocomplete-result';

@Injectable({
  providedIn: 'root',
})
export class VendorSearchService {
  private vendorsFieldSearchURL = 'vendors/autocomplete_vendor_by_name';

  private vendorsURL = 'vendors';

  constructor(private httpClient: HttpClientService) {}

  vendorsFieldSearch(term: string): Observable<AutocompleteResult[]> {
    return this.httpClient.getObservable(`${this.vendorsFieldSearchURL}.json?term=${term}`).pipe(map((response) => response as AutocompleteResult[]));
  }

  getVendorInfo(id: number): Promise<any> {
    return this.httpClient.get(`${this.vendorsURL}/${id}.json`, {
      get_name: true,
    });
  }
}
